import Icon from 'bloko/blocks/icon/Icon';
import IconDynamic from 'bloko/blocks/icon/IconDynamic';
import IconLink from 'bloko/blocks/icon/IconLink';

export { IconDynamic, IconLink };

export default Icon;
